import { defaultIconProps, IconProps } from './IconProps';

export const IconSortArrows: import('react').FC<IconProps> = ({ size, color, ...rest }) => (
  <svg data-testid="icon-sort-arrows" width={size} height={size} viewBox="0 0 20 20" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1667 3.33337V16.6667M14.1667 16.6667L10.8333 13.3334M14.1667 16.6667L17.5 13.3334M5.83333 16.6667V3.33337M5.83333 3.33337L2.5 6.66671M5.83333 3.33337L9.16667 6.66671"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconSortArrows.defaultProps = defaultIconProps;
